"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentAccessPermissionListApi = contentAccessPermissionListApi;
exports.contentAddAccessPermissionApi = contentAddAccessPermissionApi;
exports.contentBulkHardDeleteApi = contentBulkHardDeleteApi;
exports.contentCheckValidNameApi = contentCheckValidNameApi;
exports.contentCreateApi = contentCreateApi;
exports.contentDeleteApi = contentDeleteApi;
exports.contentDuplicateApi = contentDuplicateApi;
exports.contentEditorApi = contentEditorApi;
exports.contentListSoftDeleteApi = contentListSoftDeleteApi;
exports.contentPanelEditorLockApi = contentPanelEditorLockApi;
exports.contentPanelEditorUnlockApi = contentPanelEditorUnlockApi;
exports.contentRestoreBulkSoftDeleteApi = contentRestoreBulkSoftDeleteApi;
exports.contentRestoreSoftDeleteApi = contentRestoreSoftDeleteApi;
exports.contentRootNodeCreateApi = contentRootNodeCreateApi;
exports.contentSaveAsDraftApi = contentSaveAsDraftApi;
exports.contentSendNotificationApi = contentSendNotificationApi;
exports.contentSlidesApi = contentSlidesApi;
exports.contentSoftDeleteApi = contentSoftDeleteApi;
exports.contentUpdateAccessPermissionApi = contentUpdateAccessPermissionApi;
exports.contentUpdateApi = contentUpdateApi;
exports.contentUpdatePublishApi = contentUpdatePublishApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function contentCreateApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.create), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function contentUpdateApi(params) {
  return generateResponse(params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function contentUpdatePublishApi(params) {
  return generateResponse(params);
}
var generateResponse = function generateResponse(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.create), params);
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
function contentDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.deleteCpFolder), params);
}

/**
 * add access permission
 * @param payload
 * @returns api response
 * @description this function used to add access permission data.
 */
function contentAddAccessPermissionApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.accessPermission), params);
}

/**
 * update access permission
 * @param payload
 * @returns api response
 * @description this function used to update access permission data.
 */
function contentUpdateAccessPermissionApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.accessPermission), params);
}

/**
 * update access permission
 * @param payload
 * @returns api response
 * @description this function used to update access permission data.
 */
function contentSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.deleteSoft), params);
}
function contentListSoftDeleteApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.listSoftDeleted), params);
}
function contentRestoreSoftDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.softRestore), params);
}
function contentRestoreBulkSoftDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.bulkSoftRestore), params);
}
function contentBulkHardDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.bulkHardDelete), params);
}

/**
 * update access permission
 * @param payload
 * @returns api response
 * @description this function used to update access lock data.
 */
function contentPanelEditorLockApi(params) {
  var _sessionStorage;
  var headersConfig = JSON === null || JSON === void 0 ? void 0 : JSON.parse((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem("headersConfigLock"));
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.editorLock), params, headersConfig);
}

/**
 * update access permission
 * @param payload
 * @returns api response
 * @description this function used to update unlock data.
 */
function contentPanelEditorUnlockApi(params) {
  var _sessionStorage2;
  var headersConfig = JSON === null || JSON === void 0 ? void 0 : JSON.parse((_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : _sessionStorage2.getItem("headersConfigUnlock"));
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.editorUnlock), params, headersConfig);
}

/**
 * list access permission
 * @param payload
 * @returns api response
 * @description this function used to list access permission data.
 */
function contentAccessPermissionListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.accessPermission), params);
}

/**
 * check valid name
 * @param payload
 * @returns api response
 * @description this function used to check valid name.
 */
function contentCheckValidNameApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.checkName), params);
}

/**
 * content panel slides
 * @param payload
 * @returns api response
 * @description this function used to content panel slides.
 */
function contentSlidesApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.panelSlides), params);
}

/**
 * content panel slides
 * @param payload
 * @returns api response
 * @description this function used to content panel slides.
 */
function contentEditorApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.editor), params);
}

/**
 * content panel slides
 * @param payload
 * @returns api response
 * @description this function used to content panel slides.
 */
function contentFetchSoftDeletedApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.editor), params);
}

/**
 * content panel duplicate
 * @param payload
 * @returns api response
 * @description this function used to content panel duplicate.
 */
function contentDuplicateApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.copyContent), params);
}

/**
 * content panel notification
 * @param payload
 * @returns api response
 * @description this function used to content panel notification.
 */
function contentSendNotificationApi(params) {
  return api.createWithParam("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.notification), params);
}
/**
 * content panel notification
 * @param payload
 * @returns api response
 * @description this function used to content panel notification.
 */
function contentSaveAsDraftApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.saveDraft), params);
}

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function contentRootNodeCreateApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.contentPanel.createRootNode), params);
}